import React from "react";
import clsx from "clsx";
import { Box } from "@mui/material";
import { EPromptState } from "../IPrompt";
import { useStyles } from "./stateDividerStyles";
import loading_svg from "../../../assets/images/loading.svg";
import { constants } from "../../../constants";

const StateDivider = ({ promptState }: { promptState: EPromptState }) => {
    const { classes } = useStyles();
    return (
        <Box
            data-name="StateDivider"
            id="underline"
            className={clsx([classes.root])}
        >
            {promptState !== EPromptState.Initial && (
                <hr className={clsx([classes.line])} />
            )}
            {promptState === EPromptState.Thinking && (
                <Box className={classes.thinkingElements}>
                    <div className="thinking-svg">
                        <img src={loading_svg} alt="loading" />
                    </div>
                    <div className="thinking-copy">
                        {constants.copy.prompt.thinking_copy}
                    </div>
                </Box>
            )}
        </Box>
    );
};

export default StateDivider;
